import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  PromotionsWorkspace,
  type PromotionsWorkspaceProps,
} from "@/features/staff/promotions/promotions-workspace"

export default function StaffLocationManagePromotionsIndex(props: PromotionsWorkspaceProps) {
  return (
    <StaffLayout>
      <PromotionsWorkspace {...props} />
    </StaffLayout>
  )
}
